
import { defineComponent, PropType, toRefs, computed } from 'vue';
import { User } from '@/types/app';
import AppTable from '@/components/tables/base/AppTable.vue';
import Timestamp from '@/components/tables/TimestampCell.vue';
import { useTableSorting } from '@/utils';
import MaterialIcon from '@/components/MaterialIcon.vue';
import { AuthorityLevels } from '@/enums';

export default defineComponent({
  name: 'UsersTable',
  components: {
    AppTable,
    Timestamp,
    MaterialIcon
  },
  props: {
    users: {
      type: Array as PropType<Array<User>>,
      default: () => []
    }
  },
  setup(props) {
    const { users } = toRefs(props);

    const defaultTimestamp = {
      timestamp: {
        seconds: 0,
        nanoseconds: 0,
        toDate: () => new Date()
      },
      user: {
        authorityLevel: 0,
        email: '',
        id: 'FIREBASE_SYSTEM_USER',
        name: 'System'
      }
    };

    const normalizedUsers = computed(() =>
      users.value.map(user => {
        const normalizedUser = {
          ...user,
          createdOn: user.createdOn !== undefined ? user.createdOn : defaultTimestamp,
          lastUpdatedOn: user.lastUpdatedOn !== undefined ? user.lastUpdatedOn : defaultTimestamp
        };
        return normalizedUser;
      })
    );

    const { sortedData: sortedUsers, sortBy, getSortState } = useTableSorting(normalizedUsers, 'name');
    return {
      sortedUsers,
      sortBy,
      AuthorityLevels,
      getSortState
    };
  }
});
